export function getScrollbarWidth() {
    // Create the measurement node
    const scrollDiv = document.createElement('div')
    scrollDiv.className = 'scrollbar-measure'
    document.body.appendChild(scrollDiv)
    // Make box scrollable
    scrollDiv.style.overflow = 'scroll'

    // Get the scrollbar width
    const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth

    // Delete the DIV
    document.body.removeChild(scrollDiv)

    return scrollbarWidth
}

export const scrollbarWidthUnits = () => {
    // First we get the scrollbar width
    let sb = getScrollbarWidth()
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--sb', `${sb}px`)
}
